/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditListEntriesParams,
  PageAuditEntryOut,
  ProblemDetail,
  UserBrief
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Журнал действий сотрудников, новые сверху
 */
export const auditListEntries = (
    params?: AuditListEntriesParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageAuditEntryOut>(
      {url: `/api/v1/audit`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getAuditListEntriesQueryKey = (params?: AuditListEntriesParams,) => {
    return [
    `/api/v1/audit`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAuditListEntriesQueryOptions = <TData = Awaited<ReturnType<typeof auditListEntries>>, TError = ErrorType<ProblemDetail>>(params?: AuditListEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListEntries>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditListEntriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditListEntries>>> = ({ signal }) => auditListEntries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditListEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditListEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof auditListEntries>>>
export type AuditListEntriesQueryError = ErrorType<ProblemDetail>


export function useAuditListEntries<TData = Awaited<ReturnType<typeof auditListEntries>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  AuditListEntriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListEntries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditListEntries>>,
          TError,
          Awaited<ReturnType<typeof auditListEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditListEntries<TData = Awaited<ReturnType<typeof auditListEntries>>, TError = ErrorType<ProblemDetail>>(
 params?: AuditListEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListEntries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditListEntries>>,
          TError,
          Awaited<ReturnType<typeof auditListEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditListEntries<TData = Awaited<ReturnType<typeof auditListEntries>>, TError = ErrorType<ProblemDetail>>(
 params?: AuditListEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListEntries>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Журнал действий сотрудников, новые сверху
 */

export function useAuditListEntries<TData = Awaited<ReturnType<typeof auditListEntries>>, TError = ErrorType<ProblemDetail>>(
 params?: AuditListEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListEntries>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditListEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Сотрудники для фильтра журнала (включая отключённых)
 */
export const auditListUsers = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<UserBrief[]>(
      {url: `/api/v1/audit/users`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getAuditListUsersQueryKey = () => {
    return [
    `/api/v1/audit/users`
    ] as const;
    }

    
export const getAuditListUsersQueryOptions = <TData = Awaited<ReturnType<typeof auditListUsers>>, TError = ErrorType<ProblemDetail>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListUsers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditListUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditListUsers>>> = ({ signal }) => auditListUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditListUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof auditListUsers>>>
export type AuditListUsersQueryError = ErrorType<ProblemDetail>


export function useAuditListUsers<TData = Awaited<ReturnType<typeof auditListUsers>>, TError = ErrorType<ProblemDetail>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditListUsers>>,
          TError,
          Awaited<ReturnType<typeof auditListUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditListUsers<TData = Awaited<ReturnType<typeof auditListUsers>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditListUsers>>,
          TError,
          Awaited<ReturnType<typeof auditListUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditListUsers<TData = Awaited<ReturnType<typeof auditListUsers>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListUsers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сотрудники для фильтра журнала (включая отключённых)
 */

export function useAuditListUsers<TData = Awaited<ReturnType<typeof auditListUsers>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditListUsers>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditListUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




